import api from "@/services/api.service";

export default {
  name: "list",
  components: {},
  props: {
    caption: {
      type: String,
      default: "Marketing Event list"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      fields: [      
      { key: "title", sortable: true },
      { key: "campaign", sortable: true },
      // { key: "admin", sortable: true },
      { key: "vendor", sortable: true },
      { key: "actions" }
      ],
      sech: {},
      currentPage: 1,
      perPage: 10,
      totalRows: null,
      totalMarketing: null,
      isBusy: true,      
      file_path : process.env.VUE_APP_EVENT_REQUEST_FILE_URL,
      viewdata:null,
      article_modal:false,
      modalTitle:''
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.getMarketing();
  },
  watch: {
    currentPage: {
      handler: function(page) {
        this.getMarketing(page);
      }
    },    
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") 
    {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    showViewModel(data){
      this.article_modal = true
      this.viewdata = data
      this.modalTitle = "Event  : "+ data.title
      this.viewImage = (data.campaign.files[0].file_name) ? process.env.VUE_APP_IMAGE_URL + data.campaign.files[0].file_name : 'https://dummyimage.com/cga'
    },
    async toSort (page = 1)
    {   
      this.isBusy = true;
      this.sech.page = page;
      this.sech.paginateVal = this.perPage;
      let response = await api.post("marketing-event/vendor-marketing-event-list", this.sech);
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data != "") {
          this.items = response.data.data;
          this.totalMarketing = response.data.total;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;
        } else {
          this.items = [];
        }
      }      
      this.isBusy = false;
    },
    async getMarketing(page) 
    {
      this.isBusy = true;
      this.sech.page = page;
      this.sech.paginateVal = this.perPage;
      let response = await api.post("marketing-event/vendor-marketing-event-list", this.sech);
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data != "") {
          this.items = response.data.data;
          this.totalMarketing = response.data.total;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;

          this.pageOptions.forEach(element => {
            if(element.value > this.totalMarketing){
                var indexOf = this.pageOptions.indexOf(element);
                if( indexOf != 0 )
                this.pageOptions.splice(indexOf)
            }
          });
          if(this.totalMarketing <= 500)
          this.pageOptions.push({text:'All',value:this.totalMarketing});
        } else {
          this.items = [];
        }
      }      
      this.isBusy = false;
    },
    getRowCount(items) 
    {
      return items.length;
    },
    async downloadMarketingRequestContacts(event_id,request_id)
    {

      let response = await api.post("marketing-event/download-marketing-request-contacts",
        { marketing_event_id: event_id ,request_id : request_id });

      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {        
        window.open(response.data, "_blank");
        this.makeToast(`Marketing Event download successful.`,"Alert","success");
      } 
      else 
        for (var error in response.errors)
          this.makeToast(response.errors[error], 'Alert', 'danger', 6000)

      },
      downloadCampaignAsset(filename) {
        window.open(process.env.VUE_APP_IMAGE_URL+filename);
      }       
    },    
  };
